// extracted by mini-css-extract-plugin
module.exports = {"container":"BenefitTabItem_container__kJNNh","show":"BenefitTabItem_show__fi4hr","hide":"BenefitTabItem_hide__mcy47","image":"BenefitTabItem_image__MGjNI"};